/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {startLoadding, stopLoading} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {useSelector} from 'react-redux'

import {GetAllData as customNumber} from '../../CustomNumber/CustomNumberSlice/CustomNumberSlice'
import {getDedicatedNumberList} from '../../DedicatedNumber/DedicatedNumberSlice/DedicatedNumberSlice'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'
import {defaultRegion} from '../../../../../../_metronic/helpers'
import {REGION_API_URLS} from '../../../../../Utils/Constant/ConstantForWebsite'
import {GetCurrentData} from '../../../../../Utils/_helpers/GetCurrentData'
import {toLower} from 'lodash'

const API_URL = ENV().REACT_APP_API_URL
const API_URL_V3 = ENV().REACT_APP_API_V3_URL

const fetchDataApiV3 = async (url: string, data: any, region: string) => {
  const domain =
    region !== defaultRegion
      ? (region && REGION_API_URLS[region.toUpperCase()]) || API_URL_V3
      : API_URL_V3

  const response = await axios.post(`${domain}${url}`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`, region: region},
  })

  return response.data
}

const initialState = {
  businessName: [],
}

const RouteUrl = {
  GetAllData: 'business',
  GetData: '',
  EditData: '',
  DeleteData: 'business/delete',
  CreateData: 'business/add',
  setDefault: 'business/setDefault',
}

const mappingBusinessData = (item: any) => {
  return {
    _id: item?.id,
    isDeleted: false,
    isDefault: false,
    businessname: item?.number,
    user: item?.user_id,
    requestedAt: item?.approval?.requested_at,
    status: item?.is_active ? 'ACTIVE' : 'REQUESTED',
    createdBy: item?.user_id,
    updatedAt: item?.updated_at,
    approvedAt: item?.approval.approved_at,
    approvedBy: item?.approval.approved_by,
  }
}

export const GetAllData: any = createAsyncThunk('GetAllData', async () => {
  const currentUser = GetCurrentData()
  /** To get data from international service */
  if (currentUser?.region !== defaultRegion) {
    const response = await fetchDataApiV3(
      'sender',
      {
        action: 'find_business_name',
      },
      currentUser?.region as string
    )

    const items = response?.data?.items?.map(mappingBusinessData)

    const result = {data: items}
    return result
  }

  const response = await axios.get(`${API_URL}${RouteUrl.GetAllData}`, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })

  return response.data
})

export const DeleteData: any = createAsyncThunk('DeleteData', async (data, thunkApi) => {
  const currentUser = GetCurrentData()
  /** To get data from international service */
  if (currentUser?.region !== defaultRegion) {
    const response = await fetchDataApiV3(
      'sender',
      {
        action: 'delete_business_name',
        data: {
          businessNameId: data,
        },
      },
      currentUser?.region as string
    )

    response.data.is_error === false && toast.success(response.data.message)
    thunkApi.dispatch(GetAllData())
    return
  }

  const response = await axios.put(
    `${API_URL}${RouteUrl.DeleteData}/${data}`,
    {},
    {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    }
  )
  {
    response.data?.status == true && toast.success(response.data.message)
  }

  thunkApi.dispatch(GetAllData())
})
export const CreateData: any = createAsyncThunk('CreateData', async (data: any, thunkApi) => {
  thunkApi.dispatch(startLoadding())
  const currentUser = GetCurrentData()

  const request = {
    ...data
  }
  /** To get data from international service */
  if (toLower(currentUser?.region) !== defaultRegion) {
    request.region = currentUser?.region
  }

  const response = await axios.post(`${API_URL}${RouteUrl.CreateData}`, request, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  {
    response.data?.status == true && toast.success(response.data.message)
  }
  thunkApi.dispatch(stopLoading())
  thunkApi.dispatch(GetAllData())
})

export const setDefaultBusinessName: any = createAsyncThunk(
  'setDefault/bussinessName',
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.put(`${API_URL}${RouteUrl.setDefault}`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status == true && toast.success(response.data.message)
    }
    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(GetAllData())
    thunkApi.dispatch(customNumber())
    thunkApi.dispatch(getDedicatedNumberList())
  }
)
const BusinessName = createSlice({
  name: 'businessName',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetAllData.fulfilled, (state, action) => {
      return {...state, businessName: action?.payload}
    })
  },
})

export const getBusinessName = (state: any) => state?.businessName?.businessName?.data

export default BusinessName.reducer
